import { render, staticRenderFns } from "./AppUpdateCmpt.vue?vue&type=template&id=2a821b7a&lang=pug&"
import script from "./AppUpdateCmpt.vue?vue&type=script&lang=ts&"
export * from "./AppUpdateCmpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VProgressLinear,VSnackbar})
